const flowTypes = {
  review: 'review',
  addContent: 'content',
  addSingleContent: 'content/:category',
  success: 'success',
};

export default flowTypes;
